import { inject, Service } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConsumerPanelDatasource } from "../models";

@Service()
export class ConsumerPanelService {
  private http = inject(HttpClient);


  postEngineering(panel: ConsumerPanelDatasource): any {
    return this.http.post(`api/consumerpanel/engineering`, panel).pipe((s) => {
      return s;
    });
  }

  postMarketing(panel: ConsumerPanelDatasource): any {
    return this.http.post(`api/consumerpanel/marketing`, panel).pipe((s) => {
      return s;
    });
  }

  getEngineering(productId: number, regionId: number): any {
    return this.http
      .get(`api/consumerpanel/engineering/${productId}/${regionId}`)
      .pipe((s) => {
        return s;
      });
  }

  getMarketing(productId: number, regionId: number): any {
    return this.http
      .get(`api/consumerpanel/marketing/${productId}/${regionId}`)
      .pipe((s) => {
        return s;
      });
  }
}
